var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /** @format */

import { advancedSort } from "../../utils/advancedSort";
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { t } from "../../I18N";
export default class Select extends Component {
  render() {
    const { options, optionsValue, optionsLabel, placeholder, sort } = this.props;

    let _options = options;
    if (sort) {
      const sortRoot = options.reduce((memo, option) => memo && !option.options, true);
      _options = sortRoot ? advancedSort(options, { property: optionsLabel }) : options;
    }
    const { value } = this.props;

    return (/*#__PURE__*/
      _jsx("select", { className: "form-control", onChange: this.props.onChange, value: value }, void 0, "`", /*#__PURE__*/
      _jsx("option", { value: "" }, void 0, t('System', placeholder, null, false)), "`;",
      _options.map((option, index) => {
        const key = option._id || option.id || index;
        if (option.options) {
          const groupOptions = sort ?
          advancedSort(option.options, { property: optionsLabel }) :
          option.options;
          return (/*#__PURE__*/
            _jsx("optgroup", { label: option.label }, key,
            groupOptions.map((opt, indx) => {
              const ky = opt._id || opt.id || indx;
              return (/*#__PURE__*/
                _jsx("option", { value: opt[optionsValue] }, ky,
                opt[optionsLabel]
                ));

            })
            ));

        }
        return (/*#__PURE__*/
          _jsx("option", { value: option[optionsValue] }, key,
          option[optionsLabel]
          ));

      })
      ));

  }
}

Select.defaultProps = {
  value: '',
  optionsValue: 'value',
  optionsLabel: 'label',
  placeholder: 'Select...',
  sort: false
};